module.exports = __webpack_public_path__ + "img/3d_en.294982b.jpg";